import axios from 'axios'
import { ElMessage } from 'element-plus'
import { handleUnauthorized } from '@/utils/authHelper';

// 创建axios实例
// 实际服务于 /product/* 用户端接口（端口 8085）；命名沿用历史，勿按字面理解。
const service = axios.create({
  baseURL: (process.env.VUE_APP_BASE_API_USER || 'http://biocoupling.com:8085') + '/',
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// request拦截器
service.interceptors.request.use(
  config => {
    // 从localStorage获取token
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  error => {
    console.error('请求错误：', error)
    return Promise.reject(error)
  }
)

// response拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    
    // 可以根据实际接口返回格式修改
    if (res.code && res.code !== 200) {
      handleErrorResponse(res)
      return Promise.reject(new Error(res.message || '未知错误'))
    }
    return res
  },
  error => {
    handleErrorResponse(error.response)
    return Promise.reject(error)
  }
)

// 统一错误处理
const handleErrorResponse = (response) => {
  const errorMsg = response?.message || '服务器错误'
  
  // 处理常见错误码
  switch (response?.code) {
    case 401:
      handleUnauthorized('user');
      break
    case 403:
      ElMessage.error('没有权限访问')
      break
    case 404:
      ElMessage.error('请求的资源不存在')
      break
    case 500:
      ElMessage.error('服务器错误')
      break
    default:
      ElMessage.error(errorMsg)
  }
}

export default service
